import { render, staticRenderFns } from "./AlgoliaCourseHits.vue?vue&type=template&id=25c0ae62&scoped=true&"
import script from "./AlgoliaCourseHits.vue?vue&type=script&lang=ts&"
export * from "./AlgoliaCourseHits.vue?vue&type=script&lang=ts&"
import style0 from "./AlgoliaCourseHits.vue?vue&type=style&index=0&id=25c0ae62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c0ae62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('25c0ae62', component.options)
    } else {
      api.reload('25c0ae62', component.options)
    }
    module.hot.accept("./AlgoliaCourseHits.vue?vue&type=template&id=25c0ae62&scoped=true&", function () {
      api.rerender('25c0ae62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/search/AlgoliaCourseHits.vue"
export default component.exports